const debounce = (fn, delay = 100) => {
    let timeout = 0;
    const debounced = (...args) => {
        timeout && window.clearTimeout(timeout);
        timeout = window.setTimeout(() => fn(...args), delay);
    };
    return debounced;
};
export default debounce;
//# sourceMappingURL=index.js.map